import React from "react";

export default function CarDoorIcon() {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.83789 4C9.03448 4 8.26407 4.32263 7.70117 4.89453L2.57617 10.0898C2.20661 10.4641 2 10.9707 2 11.4941V18.582C2 19.8849 3.04809 21 4.36328 21H17.6367C18.9519 21 20 19.8849 20 18.582L19.9941 6.41797C19.9941 5.11508 18.9461 4 17.6309 4H9.83789ZM9.83789 6H17.6309C17.8217 6 17.9941 6.15686 17.9941 6.41797L17.9961 10H5.47266L9.125 6.29688C9.3121 6.10678 9.5693 6 9.83789 6ZM4 12H17.9961L18 18.584C17.9991 18.8438 17.827 19 17.6367 19H4.36328C4.17248 19 4 18.8431 4 18.582V12ZM11 14V16H16V14H11Z"/>
    </svg>
}